import Marionette from "backbone.marionette";
import { sizes, placeholder } from "./config";

const DEFAULTS = {
  tagName: "img",
  className: "avatar",
  attributes: {
    src: placeholder,
  },
  template: false,
  size: "small",
};

class Photo extends Marionette.ItemView {
  constructor(options = {}) {
    // apply defaults
    _.defaults(options, DEFAULTS);

    // extend with image dimensions
    Object.assign(options.attributes, sizes[options.size]);

    // extend with image URL
    if (options.url) {
      options.attributes.src = options.url;
    }

    // extend with the user's name
    // if (options.name) {
    // 	options.attributes.title = options.attributes.alt = options.name;
    // }

    super(options);
  }
}

export { Photo as default };
